module.exports = __webpack_public_path__ + "img/92.bb36b01d.jpg";